import { sendAllMessageStrings } from 'constants/strings'
import { ESendRecipient, ScheduledReservation, TTag } from 'types'
import { normalizeDraftSendOption } from '../utils'

/**
 * 配信予約の配信対象を1行のラベルにする。
 * 解釈は normalizeDraftSendOption に委ね、backend の resolveSendSegment と揃える。
 * ここで独自に判定すると、recipient を保存していなかった頃の予約（backend は
 * 全員配信として実際に送る）を「不明」と表示して止め損ねる。
 * タグ指定は名前で表示し、削除済みなどで名前を解決できないタグはID表記に落とす。
 */
export function getReservationRecipientLabel(
  reservation: ScheduledReservation,
  tags: TTag[],
): string {
  const labels = sendAllMessageStrings.reservations.recipients
  const normalized = normalizeDraftSendOption(reservation.sendOption)

  if (!normalized) return labels.unknown
  if (normalized.recipient === ESendRecipient.ALL) return labels.all
  if (normalized.recipient === ESendRecipient.UNTAGGED) return labels.untagged

  const selected = normalized.tagIds ?? []
  if (selected.length === 0) return labels.filter

  const names = selected.map((tagId) => {
    const tag = tags.find((candidate) => candidate.id === tagId)
    return tag ? tag.name : `#${tagId}`
  })
  return `${labels.filter}：${names.join('、')}`
}
